"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIPTION_EMAIL_STATUSES = exports.SUBSCRIPTION_EMAIL_STATUS = exports.EMAIL_TEMPLATE_TYPES = exports.EMAIL_TEMPLATE_TYPE = exports.ID = void 0;
var ID = 'id';
exports.ID = ID;
var EMAIL_TEMPLATE_TYPE = 'emailTemplateType';
exports.EMAIL_TEMPLATE_TYPE = EMAIL_TEMPLATE_TYPE;
var EMAIL_TEMPLATE_TYPES = {
  DRAG_AND_DROP: 'DRAG_AND_DROP',
  DESIGN_MANAGER: 'DESIGN_MANAGER'
};
exports.EMAIL_TEMPLATE_TYPES = EMAIL_TEMPLATE_TYPES;
var SUBSCRIPTION_EMAIL_STATUS = 'subscriptionEmailStatus';
exports.SUBSCRIPTION_EMAIL_STATUS = SUBSCRIPTION_EMAIL_STATUS;
var SUBSCRIPTION_EMAIL_STATUSES = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT'
};
exports.SUBSCRIPTION_EMAIL_STATUSES = SUBSCRIPTION_EMAIL_STATUSES;